import { render, staticRenderFns } from "./Box.vue?vue&type=template&id=3c804181&functional=true&lang=pug&"
var script = {}
import style0 from "./Box.vue?vue&type=style&index=0&id=3c804181&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports